export default "/assets/images/problem-solved-05.cf7992abaa77df5c.webp";